import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { LandingPage } from '../pages/landingpage'

import { CustomerInactive } from '../components/customer-inactive'
import { CustomHelmet } from '../components/CustomHelmet'
import Footer from '../components/footer'
import { NoClientIdFound } from '../components/no-client-id-found'
import { NoPropertiesFound } from '../components/no-properties-found'
import { ServerError } from '../components/server-error'
import { CustomToast } from '../components/UI/toast'

export const Route = createRootRouteWithContext<{
    queryClient: QueryClient
}>()({
    component: () => {
        return (
            <div className="flex flex-col min-h-screen">
                <CustomHelmet />

                <div className="flex flex-grow overflow-auto pb-0">
                    <Outlet />
                </div>

                <Footer />
                <div className="sm:hidden flex-grow overflow-auto pt-20"></div>
                <CustomToast />
            </div>
        )
    },
    notFoundComponent() {
        return <NoClientIdFound />
    },
    errorComponent({ error }) {
        if (['No locations found'].includes(error.message)) {
            return (
                <div className="flex flex-col min-h-screen">
                    <CustomHelmet />
                    <div className="flex flex-grow overflow-auto pb-0">
                        <LandingPage>
                            <NoPropertiesFound />
                        </LandingPage>
                    </div>
                    <Footer />
                    <div className="sm:hidden flex-grow overflow-auto pt-20"></div>
                </div>
            )
        }

        if (
            [
                'Something went wrong. Server is not reachable at the moment. Please try again later',
            ].includes(error.message)
        ) {
            return (
                <div className="flex flex-col min-h-screen">
                    <CustomHelmet />
                    <div className="flex flex-grow overflow-auto pb-0">
                        <LandingPage>
                            <ServerError />
                        </LandingPage>
                    </div>
                    <Footer />
                    <div className="sm:hidden flex-grow overflow-auto pt-20"></div>
                </div>
            )
        }

        if (error.message.includes('Could not find an active match')) {
            return (
                <div className="flex flex-col min-h-screen">
                    <CustomHelmet />
                    <NoClientIdFound />
                </div>
            )
        }

        if (error.message.includes('Customer not active')) {
            return (
                <div className="flex flex-col min-h-screen">
                    <CustomerInactive />
                </div>
            )
        }

        return (
            <div>
                An error occurred. Please try again later or contact support.
            </div>
        )
    },
})
